<template>
  <div>
    <table-view
      ref="tableList"
      tableCardTitle="LIST"
      :isTableLoading="isTableLoading"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @pageChange="pageChange"
      @searchChange="handleSearchChange"
    >
      <template v-slot:bpmId="{ tableRow }">
        <a href="javascript:void(0)" @click="handleHrefInfoPage(tableRow.row)">
          {{ tableRow.row.bpmId }}
        </a>
      </template>
      <template v-slot:customerType="{ tableRow }">
        {{
          tableRow.row.customerType === 1
            ? 'Trade'
            : tableRow.row.customerType === 2
            ? 'Eaas'
            : 'Saas'
        }}
      </template>
    </table-view>
  </div>
</template>

<script>
import { getBatchTable } from './api'

export default {
  name: 'batch-all',
  data() {
    const searchModel = [
      { label: 'Trans#', type: 'input', key: 'bpmId' },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        selectList: [
          { id: 3, name: 'Awaiting Credit Review' },
          { id: 4, name: 'Approved' },
          { id: 5, name: 'Declined' },
        ],
      },
    ]
    const tableModel = [
      { slotName: 'bpmId', label: 'Trans#' },
      { prop: 'applier', label: 'Applicant' },
      { prop: 'approver', label: 'Assigned To' },
      { prop: 'statusStr', label: 'Status' },
      { slotName: 'customerType', label: 'Customer Type', width: 200 },
    ]
    return {
      searchModel,
      tableModel,
      tableData: [],
      isTableLoading: true,
      pages: {},
    }
  },
  mounted() {
    this.initTable()
  },
  methods: {
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableList(params)
    },
    async _getTableList(params) {
      this.isTableLoading = true
      try {
        const { data, page } = await getBatchTable(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    pageChange(curPage) {
      const queryForm = {}
      const params = Object.assign({}, queryForm, {
        current: curPage.current,
        size: 10,
        status: curPage.status,
      })
      this._getTableList(params)
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableList(params)
    },
    handleHrefInfoPage(row) {
      const routeUrl = this.$router.resolve({
        name: 'batchAuditDetail',
        path: '/credit-management/credit-batch-request/audit-detail',
        query: {
          bpmId: row.bpmId,
          id: row.id,
          fileName: row.fileName,
          typeStr: row.typeStr,
          total: row.total,
        },
      })
      window.open(routeUrl.href, '_blank')
    },
  },
}
</script>

<style scoped></style>
